import { render, staticRenderFns } from "./DriversLicenseCard.vue?vue&type=template&id=61b90717&"
import script from "./DriversLicenseCard.vue?vue&type=script&lang=js&"
export * from "./DriversLicenseCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports